import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { EmotionalStory } from '../components/EmotionalStory';
import { BenefitsSection } from '../components/BenefitsSection';
import { BundleSection } from '../components/BundleSection';
import { BonusSection } from '../components/BonusSection';
import { TargetAudience } from '../components/TargetAudience';
import { PricingCTA } from '../components/PricingCTA';
import { TestimonialFooter } from '../components/TestimonialFooter';
export function LandingPage() {
  return <main className="min-h-screen w-full overflow-x-hidden bg-cream" data-id="element-207">
      <HeroSection data-id="element-208" />
      <EmotionalStory data-id="element-209" />
      <BenefitsSection data-id="element-210" />
      <BundleSection data-id="element-211" />
      <BonusSection data-id="element-212" />
      <TargetAudience data-id="element-213" />
      <PricingCTA data-id="element-214" />
      <TestimonialFooter data-id="element-215" />
    </main>;
}